import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';

import { CloseIcon } from 'assets/icons';
import { authSliceActions } from 'base/auth/slice';

import { selectStripeAccountCompleted, selectStripeConnectAlertClosed, selectStripePayoutEnabled } from 'base/auth/selectors';

import { AlertStrip } from 'components/molecules';
import { Box, IconButton, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const StripeConnectWarning = () => {
  const dispatch = useDispatch();
  const stripeAccountCompleted = useSelector(selectStripeAccountCompleted);
  const stripePayoutEnabled = useSelector(selectStripePayoutEnabled);
  const stripeConnectAlertClosed = useSelector(selectStripeConnectAlertClosed);

  return (
    (!stripeAccountCompleted || !stripePayoutEnabled) && !stripeConnectAlertClosed.isClosed
      ? (
        <AlertStrip
          color="warning"
          icon={
            <PrivacyTipIcon />
          }
          sx={{ borderBottom: '1px solid #e7e7f1' }}
          action={(
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                dispatch(authSliceActions.setStripeConnectAlertClose());
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        >
          <Box sx={{ display: 'flex' }}>
            Connect your bank account to our secure Stripe account to receive faster automated
            payouts for your paid sessions & subscriptions in accordance to our disbursement
            policy
            <Link
              to="/profile/update"
              style={{
                textDecoration: 'none', display: 'flex', alignItems: 'center', marginLeft: 10,
              }}
            >
              <Typography variant="body2" sx={{ color: 'primary.main' }}>
                Update
              </Typography>
            </Link>
          </Box>
        </AlertStrip>
      ) : (null)
  );
};

export default StripeConnectWarning;
